import React from "react";
import { Link } from "react-router-dom";
import "../App.css"


const Recipe = ({ recipe }) => {
  const { id, name, image, complexity, typeDrink, author, tequilaType, enableFoodPairing, publishdate } = recipe;

  let tequilaTypeClass = "";
  if (tequilaType === "Blanco") {
    tequilaTypeClass = "blanco-text";
  } else if (tequilaType === "Reposado") {
    tequilaTypeClass = "reposado-text";
  } else if (tequilaType === "Cristalino") {
    tequilaTypeClass = "cristalino-text";
  }

  let tequilaComplexityClass = "";
  if (complexity === "Easy") {
    tequilaComplexityClass = "easy-text";
  } else if (complexity === "Medium") {
    tequilaComplexityClass = "medium-text";
  } else if (complexity === "Hard") {
    tequilaComplexityClass = "hard-text";
  }

    
  return (
    <div className="recipe-eta">
      <Link to={`/CocktailPage/${id}`} className="recipe-card-link">
        <div className="cocktail-image">
          <img src={image} alt={name} />
        </div>
        <div className="cocktail-data">
          <h3>
            {recipe.name
              .toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
          </h3>
          <p className="cocktail-creator">{author}</p>
          <span className={tequilaComplexityClass}>{complexity}</span>
          <span className="cocktail-badge">{typeDrink}</span>
          <span className={tequilaTypeClass}>{tequilaType}</span>
          {enableFoodPairing === "YES" && (
            <span className="food-pairing-badge">Food Pairing</span>
          )}
        </div>
      </Link>
    </div>
  );
};

export default Recipe;